// growthos/warchest-frontend/react-app/src/Components/v2/atoms/ActivityItems/Comment.tsx
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Theme } from "@mui/material";
import React, { ReactNode, useState } from "react";

import { Avatar } from "@/Components/v2/atoms/Avatar";
import { Box } from "@/Components/v2/atoms/Box";
import { IconButton } from "@/Components/v2/atoms/Button";
import Menu from "@/Components/v2/atoms/Menu/Menu";
import MenuItem from "@/Components/v2/atoms/MenuItem/MenuItem";
import Stack from "@/Components/v2/atoms/Stack/Stack";
import Typography from "@/Components/v2/atoms/Typography/Typography";

import { IconContainer } from "./shared/StyledComponents";
import { Activity } from "./types";

interface CommentProps {
  theme: Theme;
  isEditable: boolean;
  isEditing: boolean;
  activity: Activity;
  initials: string;
  name: string;
  children: ReactNode;
  handleEdit?: () => void;
  handleDelete?: () => void;
  handleClose?: () => void;
}

const Comment: React.FC<CommentProps> = ({
  theme,
  isEditable,
  isEditing,
  name,
  initials,
  children,
  handleEdit,
  handleDelete,
  handleClose,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack direction="row" alignItems="flex-start" paddingY={"12px"} gap={"12px"}>
      <IconContainer>
        <Avatar
          sx={{
            width: 24,
            height: 24,
            padding: "1px",
            backgroundColor: theme.palette.avatar.background,
          }}
        >
          <Typography fontSize={12} component="div" sx={{ color: theme.palette.avatar.textColor }}>
            {initials}
          </Typography>
        </Avatar>
      </IconContainer>
      <Box style={{ flex: 1 }}>
        <Typography variant="subtitle2" component="div">
          {name}
        </Typography>
        {children}
      </Box>
      {isEditable && [
        <IconButton key="icon-button" onClick={handleMenuOpen}>
          <MoreVertIcon />
        </IconButton>,
        <Menu key="menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          {isEditing ? (
            <MenuItem
              onClick={() => {
                handleClose?.();
                handleMenuClose();
              }}
            >
              Close Edit
            </MenuItem>
          ) : (
            [
              <MenuItem
                key="edit"
                onClick={() => {
                  handleEdit?.();
                  handleMenuClose();
                }}
              >
                Edit Comment
              </MenuItem>,
              <MenuItem
                key="delete"
                onClick={() => {
                  handleDelete?.();
                  handleMenuClose();
                }}
              >
                Delete Comment
              </MenuItem>,
            ]
          )}
        </Menu>,
      ]}
    </Stack>
  );
};

export default Comment;
